/**
 * region for libraries*/
import React, { Component } from 'react';

/**
 * region for component*/
import { TableDashboard } from './TableDashboard';
import { DetailHistoryKeyword } from './DetailHistoryKeyword';

/**
 * region for helpers*/
import typing from '../../../../helpers/typing';

export class KeywordsLog extends Component {
    static displayName = KeywordsLog.name;

    constructor(props) {
        super(props);

        this.state = {
            showDetailLayer: false,
            currentDetailRow: undefined,
            filters: { ...this.props.filters },
            resetPage:  this.props.resetPage 
        };
    } 

    handleCloseShowDetailLayer() {
        this.setState({ showDetailLayer: false });
    }

    handleShowDetailLayer(row) {
        this.setState({
            showDetailLayer: true,
            currentDetailRow: row
        });
    }

    componentWillReceiveProps(nextProps) {
        if (!typing.areEqual(this.state.filters, nextProps.filters)) {
            this.setState({
                filters: { ...nextProps.filters },
                resetPage:  nextProps.resetPage 
            });
        }
    }

    render() {
        let showDetail;

        if (this.state.showDetailLayer) {
            showDetail = <DetailHistoryKeyword onCloseDetailLayer={this.handleCloseShowDetailLayer.bind(this)} detailParentRow={this.state.currentDetailRow} />
        }

        return (
            <div>  
                <div className="main-content" onClick={this.state.showDetailLayer ? this.handleCloseShowDetailLayer.bind(this) : undefined}>
                    <TableDashboard filters={this.state.filters} resetPage={this.state.resetPage} onShowDetailLayer={this.handleShowDetailLayer.bind(this)} />
                </div>
                {showDetail}                
            </div>
        );
  }
}